/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import PreviewConfig from 'material/previewconfig/previewconfig';
import AdPlacement from 'material/adplacement/adplacement';
import EmojiPreview from 'material/emojipreview/emojipreview';
// styles
import injectSheet from 'react-jss'
import styles from './preview_styles'
import Space from 'material/space/space';


/* ========== ~~~~~~~~~~ ARTICLE SENTIMENT CONFIG V2: ADS SECTION PREVIEW ~~~~~~~~~~ ========== */
const Preview = injectSheet(styles)((props) => {

  const {  
    beforeDesktopUnit,
    afterDesktopUnit,
    beforeMobileUnit,
    afterMobileUnit,
    version, 
    visibility
  } = props

  const showBeforeUnit = version === 'desktop' ? beforeDesktopUnit : beforeMobileUnit

  const showAfterUnit = version === 'desktop' ? afterDesktopUnit : afterMobileUnit

  const showAds = visibility !== 'NONE'

  return (
    <Space justifyContent={'flex-end'} klass={`preview ${props.classes.preview}`} >
    <PreviewConfig klass={`${version}`} >
        <Space gap={12} klass={'adsconfigpreview'} direction={'column'} alignItems={'center'} justifyContent={'center'}>
          { showBeforeUnit && showAds && <AdPlacement />}

          <EmojiPreview showPlaceholder headline={'What do you think?'} />

          {showAfterUnit && showAds && <AdPlacement />}
        </Space>
      </PreviewConfig>
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Preview;